export const API = process.env.REACT_APP_BACKEND;

// export const API = () => {
//   try {
//     return process.env.REACT_APP_BACKEND;
//   } catch (error) {
//     console.log(error);
//   }
// };
